import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../../http.service';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  
  logoImage='assets/img/logo.png';
  constructor(private _http: HttpService) { }

  ngOnInit(): void {
	
  }
  
 
}
